/**
 * ss-proof-slider.js — Trusted by UK vapers (mobile swipe + dots, desktop grid)
 */
(function () {
  'use strict';

  var MQ = '(max-width: 749px)';

  function init(track) {
    if (!track || track.dataset.ssProofInit) return;

    var cards = track.querySelectorAll('.ss-proof__card');
    if (cards.length < 2) return;

    var mobile = window.matchMedia(MQ);
    if (!mobile.matches) return;

    track.dataset.ssProofInit = '1';

    var index = 0;
    var section = track.closest('.ss-proof');
    if (!section) return;

    var wrap = track.parentElement;
    if (wrap) wrap.classList.add('ss-proof__cards-wrap');

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'ss-proof__dots';
    dotsWrap.setAttribute('role', 'tablist');
    dotsWrap.setAttribute('aria-label', 'Review platforms');

    cards.forEach(function (_card, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ss-proof__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Slide ' + (i + 1));
      dot.addEventListener('click', function () { scrollToIndex(i); });
      dotsWrap.appendChild(dot);
    });

    if (wrap) wrap.appendChild(dotsWrap);

    function updateDots() {
      dotsWrap.querySelectorAll('.ss-proof__dot').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function scrollToIndex(i) {
      index = (i + cards.length) % cards.length;
      var card = cards[index];
      if (!card) return;
      track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
      updateDots();
    }

    track.addEventListener('scroll', function () {
      var left = track.scrollLeft;
      var closest = 0;
      var min = Infinity;
      cards.forEach(function (card, i) {
        var d = Math.abs(card.offsetLeft - left);
        if (d < min) {
          min = d;
          closest = i;
        }
      });
      if (closest !== index) {
        index = closest;
        updateDots();
      }
    }, { passive: true });
  }

  function boot() {
    document.querySelectorAll('[data-ss-proof-slider]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-ss-proof-slider]').forEach(function (track) {
      track.removeAttribute('data-ss-proof-init');
      init(track);
    });
  });
  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-ss-proof-slider][data-ss-proof-init]').forEach(function (track) {
      track.removeAttribute('data-ss-proof-init');
      var wrap = track.parentElement;
      if (wrap) {
        wrap.classList.remove('ss-proof__cards-wrap');
        var dots = wrap.querySelector('.ss-proof__dots');
        if (dots) dots.remove();
      }
    });
    boot();
  }, { passive: true });
})();
